import type { BaggageFuelEconomyPayload } from '@makemydeal/dr-dash-bff-types';
import type { BaggageFuelEconomyState, StateTree } from '@makemydeal/dr-dash-types';

/**
 * Returns the entire baggageFuelEconomy state slice
 */
export const getBaggageFuelEconomyState = (state: StateTree): BaggageFuelEconomyState | undefined => {
    return state.baggageFuelEconomy;
};

/**
 * Returns the baggageFuelEconomy payload if it contains vehicles or trades data
 */
export const getBaggageFuelEconomy = (state: StateTree): BaggageFuelEconomyPayload | undefined => {
    const payload = getBaggageFuelEconomyState(state)?.payload;

    if (!payload) {
        return undefined;
    }

    // Return undefined if payload exists but has no vehicles or trades (or they're empty)
    const hasVehicles = payload.vehicles && Object.keys(payload.vehicles).length > 0;
    const hasTrades = payload.trades && Object.keys(payload.trades).length > 0;

    if (!hasVehicles && !hasTrades) {
        return undefined;
    }

    return payload;
};
